module.exports = __webpack_public_path__ + "img/image120.3479748d.jpg";